import React from "react";
import { Sparkle } from "lucide-react";

const voices = [
  {
    quote:
      "Denisse has a sixth sense for which room a brand actually belongs in. She closes the right deals and quietly opens the right doors.",
    name: "Sofía Mendez",
    role: "Founder, Cielo Beauty",
  },
  {
    quote:
      "NOVA MEDIA produced the kind of New York dinner you read about for months. It moved product the same week — that almost never happens.",
    name: "Marc Beaulieu",
    role: "CMO, Maison Beaulieu",
  },
  {
    quote:
      "Half PR studio, half growth team. Denisse rewires how founders think about influence — taste first, but always tied to revenue.",
    name: "Priya Kapoor",
    role: "GP, Atelier Ventures",
  },
];

export default function Testimonials() {
  return (
    <section
      id="voices"
      data-testid="testimonials-section"
      className="relative bg-[#080808] py-16 md:py-24 lg:py-32 border-y border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-3">
            <span className="text-[10px] uppercase tracking-[0.35em] text-[#7FB3D5]">
              ✦ The voices
            </span>
            <p className="mt-6 text-[10px] uppercase tracking-[0.3em] text-white/40">
              Page 07
            </p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2 className="font-display text-4xl md:text-6xl lg:text-7xl text-white leading-[0.95] tracking-tight font-light">
              From the
              <span className="italic text-[#7FB3D5]"> right rooms</span>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {voices.map((v, i) => (
            <figure
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="relative border border-white/10 bg-[#050505] p-8 md:p-10 hover:border-[#7FB3D5]/40 transition-colors duration-500 group"
            >
              <Sparkle
                className="absolute -top-3 left-8 w-6 h-6 text-[#7FB3D5] bg-[#080808] p-0.5"
                fill="#7FB3D5"
                strokeWidth={0.6}
              />
              <blockquote className="font-display text-xl md:text-2xl text-white/90 leading-snug italic font-light">
                &ldquo;{v.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10">
                <div className="font-display text-lg text-white">{v.name}</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#7FB3D5] mt-1">
                  {v.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
